import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withContext, getMarginBottomClass, marginBottomLevels } from '@piggybank/core';
import { Consumer } from '../Field/context.js';
import { Provider } from './context.js';
import styles from './label.css.js';

var Label = function Label(_ref) {
  var name = _ref.name,
      children = _ref.children,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? 2 : _ref$marginBottom,
      rest = _objectWithoutProperties(_ref, ["name", "children", "marginBottom"]);

  return React.createElement("label", _extends({
    className: cn(styles['Label'], getMarginBottomClass(marginBottom)),
    htmlFor: name ? "".concat(name, "-field") : null,
    id: name ? "".concat(name, "-field-label") : null
  }, rest), React.createElement(Provider, {
    value: {
      inLabel: true
    }
  }, children));
};

Label.propTypes = process.env.NODE_ENV !== "production" ? {
  /** docgen-from-context:<Field/> */
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels)
} : {};
var Label$1 = withContext(Consumer, function (value) {
  return {
    name: value.name
  };
})(Label);
export default Label$1;
export { Label };